export function shouldShowPhoneOverlay({ overlayTemplate, isScreenView, isBandView }) {
  return Boolean(overlayTemplate) && !isScreenView && !isBandView;
}
